export const DepartmentPath = ["name", "description", "status"]

export const DepartmentHeading = (t) => [
    { title: t("Name"), field: "name" },
    { title: t("Department Manager"), field: "manager" },
    { title: t("Description"), field: "description" },
    { title: t("Status"), field: "status", },
    { title: "", field: "icon" },
]

export const DepartmentType = [
    { type: ["text"], name: "name" },
    { type: ["text"], name: "manager" },
    { type: ["text"], name: "description" },
    { type: ["status"], name: "status" },
    { type: ["more"], icon: "icon" },
]

export const StatusOptionListMap = [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
]